import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { SalesOrderLinesRequestDto } from "../models/orders/salesOrderLinesRequestDto";
import { CreateSalesOrderLineResponseDto } from "../models/orders/createSalesOrderLineResponseDto";
import { SalesOrderLine } from "../models/orders/saleOrderLine";
import { SaleOrderLineAddressDto } from "../models/orders/saleOrderLineAddressDto";
import { SaleOrderResponseDto } from "../models/orders/saleOrderResponseDto";
import { SalesOrderLinesResponseDto } from "../models/orders/salesOrderLinesResponseDto";
import { SaveAndConfirmAllSaleOrderLinesResponseDto } from "../models/orders/saveAndConfirmAllSaleOrderLinesResponseDto";
import { UpdateSalesOrderLineDto } from "../models/orders/updateSalesOrderLineDto";
import { UpdateSOLineResponseDto } from "../models/orders/updateSOLineResponseDto";
import { CheckCurrencyMismatchRequestDto } from "../models/common/checkCurrencyMismatchRequestDto";
import { CheckCurrencyMismatchResponseDto } from "../models/common/checkCurrencyMismatchResponseDto";

@Injectable({
  providedIn: "root",
})
export class OrderLineItemService {
  private saleOrderManagementBaseURL =
    environment.baseUrl + "/SalesOrderManagement";
  private clientManagementBaseURL = environment.baseUrl + "/ClientManagement";
  private quotesManagementBaseURL = environment.baseUrl + "/QuotesManagement";

  constructor(private _http: HttpClient) {}

  addSaleOrderLineData(
    payload: SalesOrderLinesRequestDto
  ): Observable<GenericResponseDto<CreateSalesOrderLineResponseDto>> {
    return this._http.post<GenericResponseDto<CreateSalesOrderLineResponseDto>>(
      this.saleOrderManagementBaseURL + "/AddSalesOrderLines",
      payload
    );
  }

  IsUserBlockedFromEdit(
    saleOrderId = ""
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.get<GenericResponseDto<boolean>>(
      this.saleOrderManagementBaseURL +
        `/IsUserBlockedFromEdit?SalesOrderId=${saleOrderId}`
    );
  }

  getSaleOrderData(
    id: string
  ): Observable<GenericResponseDto<SaleOrderResponseDto>> {
    return this._http.get<GenericResponseDto<SaleOrderResponseDto>>(
      this.saleOrderManagementBaseURL + "/GetSaleOrder?SaleOrderId=" + id
    );
  }

  saveSalesOrderLines(
    payload: SalesOrderLinesRequestDto
  ): Observable<GenericResponseDto<SalesOrderLine[]>> {
    return this._http.post<GenericResponseDto<SalesOrderLine[]>>(
      this.saleOrderManagementBaseURL + "/saveSalesOrderLines",
      payload
    );
  }

  saveAndConfirmAllSaleOrderLines(
    id: string
  ): Observable<
    GenericResponseDto<SaveAndConfirmAllSaleOrderLinesResponseDto>
  > {
    return this._http.get<
      GenericResponseDto<SaveAndConfirmAllSaleOrderLinesResponseDto>
    >(
      this.saleOrderManagementBaseURL +
        "/SaveAndConfirmAllSaleOrderLines?SaleOrderId=" +
        id
    );
  }

  syncCopiedSalesOrderLines(
    id: string
  ): Observable<GenericResponseDto<CreateSalesOrderLineResponseDto>> {
    return this._http.get<GenericResponseDto<CreateSalesOrderLineResponseDto>>(
      this.saleOrderManagementBaseURL +
        "/SyncCopiedSalesOrderLines?SaleOrderId=" +
        id
    );
  }

  createSaleOrderLine(
    payload: SalesOrderLinesRequestDto
  ): Observable<GenericResponseDto<SalesOrderLinesResponseDto>> {
    return this._http.post<GenericResponseDto<SalesOrderLinesResponseDto>>(
      this.saleOrderManagementBaseURL + "/CreateSaleOrderLine",
      payload
    );
  }

  updateSaleOrderLine(
    payload: UpdateSalesOrderLineDto
  ): Observable<GenericResponseDto<UpdateSOLineResponseDto>> {
    return this._http.post<GenericResponseDto<UpdateSOLineResponseDto>>(
      this.saleOrderManagementBaseURL + "/UpdateSalesOrderLine",
      payload
    );
  }

  getPartyNumberByAccountNumber(
    accountNumber: string
  ): Observable<GenericResponseDto<string>> {
    return this._http.get<GenericResponseDto<string>>(
      this.clientManagementBaseURL +
        `/GetPartyNumberByAccountNumber?accountNumber=${accountNumber}`
    );
  }
  getSaleOrderLineNumber(
    saleOrderId: string
  ): Observable<GenericResponseDto<number>> {
    return this._http.get<GenericResponseDto<number>>(
      this.saleOrderManagementBaseURL +
        `/GetSaleOrderLineNumber?SaleOrderId=${saleOrderId}`
    );
  }

  updateOrderLineItemSequence(
    payload: SaleOrderLineAddressDto[]
  ): Observable<GenericResponseDto<SaleOrderLineAddressDto[]>> {
    return this._http.post<GenericResponseDto<SaleOrderLineAddressDto[]>>(
      this.saleOrderManagementBaseURL + "/UpdateOrderLineItemSequence",
      payload
    );
  }

  checkCurrencyMismatch(
    payload: CheckCurrencyMismatchRequestDto
  ): Observable<GenericResponseDto<CheckCurrencyMismatchResponseDto>> {
    return this._http.post<
      GenericResponseDto<CheckCurrencyMismatchResponseDto>
    >(this.quotesManagementBaseURL + "/CheckCurrencyMismatch", payload);
  }
}
